import { render, staticRenderFns } from "./Migrate.vue?vue&type=template&id=8b4c2c18&scoped=true&"
import script from "./Migrate.vue?vue&type=script&lang=js&"
export * from "./Migrate.vue?vue&type=script&lang=js&"
import style0 from "./Migrate.vue?vue&type=style&index=0&id=8b4c2c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4c2c18",
  null
  
)

export default component.exports